import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Scrollbar } from 'swiper';
import './ArtistPopUp.scss';

SwiperCore.use([Scrollbar]);

const ArtistPopUp = ({ artist, className, onClose, ...props }) => {
  const [swiper, setSwiper] = useState(null);
  const ref = useRef(null);
  const swiperParams = {
    speed: 100,
    spaceBetween: '5%',
    slidesPerView: 1.3,
    freeMode: true,
    scrollbar: {
      el: '.myCustomScrollbar',
      draggable: true,
      snapOnRelease: true,
      dragSize: 40,
    },
    breakpoints: {
      768: {
        slidesPerView: 2.8,
      },
    },
    onSlideChange,
  };

  const {
    name,
    surname,
    country: location,
    instrument,
    photo: profilePicture,
    bio: about,
    gallery: photos,
    role: type,
  } = artist !== null && artist;

  function onSlideChange (e) {
    const endpointStyle = document.querySelector('.scrollbarEndPoint').style;
    endpointStyle.opacity = e.realIndex === e.slides.length - 1 ? 0 : 1;
  }

  function closePopup () {
    document.querySelector('.artist__popup').classList.remove('show');
    document.body.style.overflow = 'unset';
    setTimeout(() => onClose(), 600);
  }

  function hidePopupWithEsc (e) {
    e.keyCode === 27 && closePopup();
  }

  useEffect(() => {
    window.addEventListener('keyup', hidePopupWithEsc);
    return () => window.removeEventListener('keyup', hidePopupWithEsc);
  }, []);

  useEffect(() => {
    if (artist) {
      if (ref.current !== null && ref.current.swiper !== null) {
        swiper.update();
      }
      document.body.style.overflow = 'hidden';

      document.querySelector('.faded__background').style.height = `${
        document.querySelector('.popup__content').clientHeight * 1.2
      }px`;
      document.querySelector('.artist__popup').scrollTo(0, 0);
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [artist, swiper]);
  return (
    <>
      <div className={`artist__popup ${className} ${type}`}>
        <div className='faded__background' onClick={closePopup} />

        <div className='popup__content'>
          <div className='popup__header'>
            <button onClick={closePopup} className='close__btn'>
              <img src='/media/icons/inclassica/close.svg' alt='close' />
            </button>
            <div className='popup__header__text'>
              <h1 className='artist__name'>
                {type === 'orchestra' ? name : `${name} ${surname}`}
              </h1>
              <p className='artist__details'>
                {type === 'soloist' && instrument && `${instrument} |`}
                <span className='artist__location'> {location} </span>
              </p>
            </div>

            <div
              className='popup__header__img'
              style={{ backgroundImage: `url(${profilePicture})` }}
            />
          </div>

          <div className='popup__body'>
            <h3>BIOGRAPHY</h3>
            <p
              className='artist__bio'
              dangerouslySetInnerHTML={{ __html: about }}
            />

            <div className='artist__images'>
              <Swiper
                {...swiperParams}
                className='artist__slider'
                ref={ref}
                onInit={(swiper) => setSwiper(swiper)}
              >
                {artist &&
                  photos &&
                  photos.map((img, i) => (
                    <SwiperSlide
                      key={i}
                      className='artist__img'
                      style={{ backgroundImage: `url(${img})` }}
                    />
                  ))}
              </Swiper>
              <div className='scrollbarContainer'>
                <div className='myCustomScrollbar'>
                  <div className='scrollbarEndPoint' />
                  <div className='scrollbarStartPoint' />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

ArtistPopUp.propTypes = {
  artist: PropTypes.object,
  className: PropTypes.string,
  onClose: PropTypes.func,
};

export default ArtistPopUp;
